export default __webpack_public_path__ + "static/media/crispr.e32bf813.png";